import { useFormik } from "formik";
import RadioInput from "../../common/RedioComponent/RadioInput";
import Header from "../../component/Header";
import Layout from "../../component/Layout";
import UsePagination from "../../component/pagination";
import * as S from "./MedicalRecords4.Styles";
import { useState } from "react";
import * as yup from "yup";
import MobileVerify from "../../component/Modal/verifyMobileModal";
const MedicalRecords4 = ({ step, setStep }) => {
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const radioOption = [
    { label: "بله", value: "lab" },
    { label: "خیر", value: "non-lab" },
  ];

  const checkOption = [
    { label: "کمتر از ۴  mmol/L (کمتر از ۷۲  mg/dl)", value: "3.9" },
    {
      label: "بین ۴ تا۵ mmol/L (بین ۷۲ تا۹۰ mg/dl)",
      value: "4",
    },
    { label: "بین ۵ تا۶ mmol/L ( بین ۹۰ تا ۱۰۸  mg/dl)", value: "5" },
    { label: "بین ۶ تا۷ mmol/L ( بین ۱۰۸ تا ۱۲۹    mg/dl)", value: "6" },
    { label: "بیشتر از ۷  mmol/L (بیشتر از ۱۲۹  mg/dl)", value: "7" },
  ];

  const initialValues = {
    type: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].type
      : "",

    cholesterol: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].cholesterol
      : "",
  };

  //2.
  const onSubmit = (values) => {
    const datas = JSON.parse(localStorage.getItem("infoPerson"));
    let info = localStorage.getItem("infoPerson");
    if (info) {
      let parseInfo = JSON.parse(info);
      parseInfo[6] = values;

      localStorage.setItem("infoPerson", JSON.stringify(parseInfo));
    } else {
      datas.push(values);
      localStorage.setItem("infoPerson", JSON.stringify(datas));
    }

    setOpenModalSearch(true);
  };

  //3.
  const validationSchema = yup.object({
    type: yup.string().required("یک گزینه را وارد کنید"),

    cholesterol: yup.string().when("type", {
      is: "lab",
      then: () => yup.string().required("I am required "),
    }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <>
      <MobileVerify
        open={openModalSearch}
        onClose={() => setOpenModalSearch(false)}
      />
      <Header>
        <S.BgHeader style={{ backgroundImage: `url("images/Header2.png")` }}>
          <S.ContentHeader>
            <S.TitleHeader>سوابق پزشکی</S.TitleHeader>
            <img src="/images/medication.png" width={128} alt="header" />
          </S.ContentHeader>
        </S.BgHeader>
      </Header>
      <Layout>
        <S.Container>
          <S.Title> آیا در یکسال اخیر آزمایش خون داده‌اید؟</S.Title>
          <S.RadioWrraper>
            <form onSubmit={formik.handleSubmit}>
              <RadioInput
                formik={formik}
                name={"type"}
                radioOption={radioOption}
              />

              {formik.values.type === "lab" ? (
                <>
                  <S.Smooke>
                    <S.Title>
                      میزان کلسترول کل شما حدودا در چه محدوده‌ای قرار دارد:
                    </S.Title>
                    <RadioInput
                      formik={formik}
                      name={"cholesterol"}
                      radioOption={checkOption}
                    />
                  </S.Smooke>
                </>
              ) : (
                ""
              )}

              <UsePagination step={step} setStep={setStep} formik={formik} />
            </form>
          </S.RadioWrraper>
        </S.Container>
      </Layout>
    </>
  );
};

export default MedicalRecords4;
